import { useCallback, useEffect, useMemo, useState } from "react";
import Vehicle from "../passapp-sdk/vehicle";
import { useStore } from "./useStore";
import { SelectOption } from "../components/common/PL/Select/Select";

const vehicleApi = new Vehicle();

/** Marca tal como la devuelve el backend. `id` se agregó después: cuando falta, el value del select
 * cae al nombre y `addVehicle` recibe sólo el `brand` legacy. */
export type VehicleBrand = { id?: string; name: string };

const useVehicleBrands = () => {
  const { authStore } = useStore();
  const [brands, setBrands] = useState<SelectOption[]>([]);
  const [rawBrands, setRawBrands] = useState<VehicleBrand[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchBrands = useCallback(
    async (search?: string) => {
      if (!authStore.token) return;
      setLoading(true);
      try {
        const response = await vehicleApi.getVehicleBrands(
          authStore.token,
          search
        );
        if (response?.data) {
          const brandsArray = (Array.isArray(response.data)
            ? response.data
            : Object.values(response.data)) as VehicleBrand[];
          // El value sigue siendo el nombre: es lo que espera el `brand` legacy y lo que ya tienen
          // guardados los vehículos. El id se resuelve por nombre contra `rawBrands` cuando hace
          // falta mandar `brandId`.
          const options: SelectOption[] = brandsArray.map(
            (brand: VehicleBrand) => ({
              value: brand.name,
              label: brand.name,
            })
          );
          setRawBrands(brandsArray);
          setBrands(options);
        }
      } catch (err) {
        console.error("Error fetching vehicle brands:", err);
      } finally {
        setLoading(false);
      }
    },
    [authStore.token]
  );

  useEffect(() => {
    fetchBrands();
  }, [fetchBrands]);

  return { brands, rawBrands, loading, fetchBrands };
};

export default useVehicleBrands;
